module.exports = __webpack_public_path__ + "5906f925155aa9708c386c5ab297daec.svg";